import { IEnvWeb } from "~/types/api-types";

import {
  KLARNA_SUPPORTED_COUNTRIES,
  KLARNA_SUPPORTED_CURRENCIES,
  STRIPE_PUBLIC_KEY_BY_COUNTRY_MAP,
} from "./stripe.constants";

const getStripePublicKey = (countryKey: string, keys: IEnvWeb["stripe"]) => {
  const keyByCountry =
    STRIPE_PUBLIC_KEY_BY_COUNTRY_MAP[
      countryKey as keyof typeof STRIPE_PUBLIC_KEY_BY_COUNTRY_MAP
    ];
  return keys[keyByCountry as keyof IEnvWeb["stripe"]];
};

const isKlarnaSupported = (currency = "", country = "") => {
  const isCurrencySupported = KLARNA_SUPPORTED_CURRENCIES.has(
    currency.toLowerCase(),
  );
  const isCountrySupported = KLARNA_SUPPORTED_COUNTRIES.has(
    country.toLowerCase(),
  );

  return isCurrencySupported && isCountrySupported;
};

const formatStripeAmount = (amount: number) => Math.floor(amount * 100);

export { getStripePublicKey, isKlarnaSupported, formatStripeAmount };
